import base from './base.css.js';
import { createStyleTag } from './create-style-tag.js';
import { themes } from './themes/index.js';
import './themes/light-classic/index.js';
import './themes/dark-classic/index.js';
import './themes/dark/index.js';
import './themes/light/index.js';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const themeStyleTag = createStyleTag();
let currentTheme;
const updateTheme = /* @__PURE__ */ __name(() => {
  var _a;
  const themeStyle = (_a = themes) == null ? void 0 : _a[currentTheme];
  const currentStyleTag = document.querySelector("#mds-theme-style");
  if (currentStyleTag && themeStyle) {
    currentStyleTag.innerHTML = base + themeStyle;
  }
}, "updateTheme");
const getTheme = /* @__PURE__ */ __name(() => currentTheme, "getTheme");
const setTheme = /* @__PURE__ */ __name((theme) => {
  currentTheme = theme;
  updateTheme();
}, "setTheme");
const setDefaultTheme = /* @__PURE__ */ __name(() => {
  if (themeStyleTag && document) {
    setTheme("light-classic");
  }
}, "setDefaultTheme");
setDefaultTheme();

export { getTheme, setDefaultTheme, setTheme };
//# sourceMappingURL=theme.js.map
